
import { baseList } from "@/api/login/login.js";
export default {
  name: 'drawMixin',
  data() {
    return {

    }
  },
  mounted() {

  },
  created() {

  },
  watch: {
    item: {
      handler(newVal2) {
        if (newVal2.id) {

          this.baseList(newVal2)
        }
      },
      immediate: true
    },
  },
  methods: {
    async baseList(value) {

      try {
        if (value.bgiFileId) {
          if (value.bgiFileId.length < 40) {

            const res = await baseList(value.bgiFileId);
            value.bgiFileId = "data:image/png;base64," + res.data;
          }
        }

        if (value.scaleOptions) {
          value.scaleOptions.forEach(async obj => {
            if (obj.fileId.length < 40) {

              const { data } = await baseList(obj.fileId);
              obj.fileId = "data:image/png;base64," + data;
            }
          });
        }
      } catch (error) {
        console.log(error);
      }
    },


  },
}


